import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "io-hero__container" }
const _hoisted_2 = { class: "io-hero__container__content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "container-fluid" }

import {
  reactive,
  computed,
  onMounted,
  onBeforeUnmount,
  ref,
  watch,
  nextTick, useSlots,
} from 'vue';

import LazyBackgroundMedia from '@/components/LazyBackgroundMedia.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Hero',
  props: {
  contentAlign: {
    type: String,
    required: false,
    default: () => 'top',
  },
  height: {
    type: String,
    required: false,
    default: 'medium',
  },
  mediaId: {
    type: String,
    required: false,
    default: () => '0',
  },
  mediaSizes: {
    type: [String, Object],
    required: false,
  },
  mediaAlt: {
    type: String,
    required: false,
    default: () => '',
  },
  mediaCalcOneId: {
    type: String,
    required: false,
    default: () => '0',
  },
  mediaCalcOneSizes: {
    type: [String, Object],
    required: false,
  },
  mediaCalcOneAlt: {
    type: String,
    required: false,
    default: () => '',
  },
  mediaCalcTwoId: {
    type: String,
    required: false,
    default: () => '0',
  },
  mediaCalcTwoSizes: {
    type: [String, Object],
    required: false,
  },
  mediaCalcTwoAlt: {
    type: String,
    required: false,
    default: () => '',
  },
  mediaCalcThreeId: {
    type: String,
    required: false,
    default: () => '0',
  },
  mediaCalcThreeSizes: {
    type: [String, Object],
    required: false,
  },
  mediaCalcThreeAlt: {
    type: String,
    required: false,
    default: () => '',
  },
  mediaCalcFourId: {
    type: String,
    required: false,
    default: () => '0',
  },
  mediaCalcFourSizes: {
    type: [String, Object],
    required: false,
  },
  mediaCalcFourAlt: {
    type: String,
    required: false,
    default: () => '',
  },
  backgroundPositionY: {
    type: String,
    required: false,
    default: () => 'top',
  },
  backgroundPositionX: {
    type: String,
    required: false,
    default: () => 'center',
  },
  backgroundCalcOnePositionY: {
    type: String,
    required: false,
    default: () => 'top',
  },
  backgroundCalcOnePositionX: {
    type: String,
    required: false,
    default: () => 'center',
  },
  backgroundCalcTwoPositionY: {
    type: String,
    required: false,
    default: () => 'top',
  },
  backgroundCalcTwoPositionX: {
    type: String,
    required: false,
    default: () => 'center',
  },
  backgroundCalcThreePositionY: {
    type: String,
    required: false,
    default: () => 'top',
  },
  backgroundCalcThreePositionX: {
    type: String,
    required: false,
    default: () => 'center',
  },
  backgroundCalcFourPositionY: {
    type: String,
    required: false,
    default: () => 'top',
  },
  backgroundCalcFourPositionX: {
    type: String,
    required: false,
    default: () => 'center',
  },
  fontColor: {
    type: String,
    required: false,
    default: () => 'white',
  },
  pageUrl: {
    type: String,
    required: false,
    default: () => null,
  },
  pageUrlLabel: {
    type: String,
    required: false,
    default: () => 'Mehr erfahren',
  },
  calculatorShow: {
    type: String,
    required: false,
    default: () => 'false',
  },
  calculatorBranches: {
    type: String,
    required: false,
    default: () => 'all',
  },
  calculatorLabelExtra: {
    type: String,
    required: false,
    default: () => null,
  },
},
  setup(__props) {

const props = __props;
const slots = useSlots();
const header = reactive({
  $el: null as null | HTMLElement,
});
const heroContainer = ref<InstanceType<typeof HTMLElement>>();
const root = ref<InstanceType<typeof HTMLElement>>();
const background = ref<InstanceType<typeof LazyBackgroundMedia>>();
const heroCalculator = ref<InstanceType<typeof HTMLElement>>();
const calculatorComponent = ref();
const isMobile = ref(false);
const currentSelectedUsage = ref<number | null>(null);
const currentMedia = computed<Record<symbol, unknown>>(() => {
  const m = {
    id: props.mediaId,
    sizes: props.mediaSizes,
    alt: props.mediaAlt,
    positionX: props.backgroundPositionX,
    positionY: props.backgroundPositionY,
  };

  if (props.calculatorShow === 'true') {
    if (currentSelectedUsage.value === 2 && props.mediaCalcTwoId && props.mediaCalcTwoId !== '0') {
      m.id = props.mediaCalcTwoId;
      m.sizes = props.mediaCalcTwoSizes;
      m.alt = props.mediaCalcTwoAlt;
      m.positionX = props.backgroundCalcTwoPositionX;
      m.positionY = props.backgroundCalcTwoPositionY;
    } else if (currentSelectedUsage.value === 3 && props.mediaCalcThreeId && props.mediaCalcThreeId !== '0') {
      m.id = props.mediaCalcThreeId;
      m.sizes = props.mediaCalcThreeSizes;
      m.alt = props.mediaCalcThreeAlt;
      m.positionX = props.backgroundCalcThreePositionX;
      m.positionY = props.backgroundCalcThreePositionY;
    } else if (currentSelectedUsage.value === 4 && props.mediaCalcFourId && props.mediaCalcFourId !== '0') {
      m.id = props.mediaCalcFourId;
      m.sizes = props.mediaCalcFourSizes;
      m.alt = props.mediaCalcFourAlt;
      m.positionX = props.backgroundCalcFourPositionX;
      m.positionY = props.backgroundCalcFourPositionY;
    } else if ([null, 0, 1].indexOf(currentSelectedUsage.value) >= 0 && props.mediaCalcOneId && props.mediaCalcOneId !== '0') {
      m.id = props.mediaCalcOneId;
      m.sizes = props.mediaCalcOneSizes;
      m.alt = props.mediaCalcOneAlt;
      m.positionX = props.backgroundCalcOnePositionX;
      m.positionY = props.backgroundCalcOnePositionY;
    }
  }

  return m;
});

const subline = slots.subline ? slots.subline() : null;
const hasSubline = computed(() => (
  subline && subline[0] ? `${subline[0].children}`.trim().length > 0 : false
));
const content = slots.content ? slots.content() : null;
const hasContent = computed(() => (
  content && content[0] ? `${content[0].children}`.trim().length > 0 : false
));

const minHeight = ref<number | null>(null);

const setMinHeight = () => {
  minHeight.value = null;
  let headerHeight = 0;

  if (header.$el) {
    headerHeight = header.$el.offsetHeight;
  }

  if (!isMobile.value) {
    switch (props.height) {
      case 'full':
        minHeight.value = window.innerHeight - headerHeight;
        break;
      case 'small':
        minHeight.value = (window.innerHeight - headerHeight) * 0.59537;
        break;
      case 'auto':
        minHeight.value = 0;
        break;
      default:
        minHeight.value = (window.innerHeight - headerHeight) * 0.68796;
    }
  }
};

const setIsMobile = () => {
  if (background.value && background.value.$el) {
    const {
      position,
    } = getComputedStyle(background.value.$el);

    isMobile.value = position !== 'absolute';
  } else {
    isMobile.value = false;
  }
};

const resizeHandler = () => {
  setMinHeight();
  setIsMobile();
};

const heroClasses = [
  'io-hero',
  `text-${props.fontColor}`,
];

onMounted(() => {
  header.$el = document.querySelector('header');
  window.addEventListener('resize', resizeHandler);
  window.addEventListener('load', resizeHandler);
  resizeHandler();
  for (let i = 100; i < 1000; i += 100) {
    setTimeout(resizeHandler, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeHandler);
  window.removeEventListener('load', resizeHandler);
});

watch(() => calculatorComponent.value, () => {
  nextTick(resizeHandler);
});

const onCalculatorChangeIcon = (icon: number) => {
  currentSelectedUsage.value = icon;
};

return (_ctx: any,_cache: any) => {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!
  const _component_BaseCalculator = _resolveComponent("BaseCalculator")!
  const _component_BaseGridCol = _resolveComponent("BaseGridCol")!
  const _component_BaseGridRow = _resolveComponent("BaseGridRow")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(heroClasses)
  }, [
    _createVNode(_component_BaseGridRow, {
      "min-height": minHeight.value,
      g: 0,
      "vertical-center": __props.contentAlign === 'center',
      "vertical-end": __props.contentAlign === 'end'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseGridCol, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "container-fluid",
                ref_key: "heroContainer",
                ref: heroContainer
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_IoHeadline, {
                    size: "h1",
                    "text-align": "start",
                    color: "dark",
                    "color-lg": __props.fontColor
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "headline")
                    ]),
                    _: 3
                  }, 8, ["color-lg"]),
                  (hasSubline.value)
                    ? (_openBlock(), _createBlock(_component_IoHeadline, {
                        key: 0,
                        size: "h1",
                        "tag-name": "h2",
                        "text-align": "start",
                        color: "dark",
                        "color-lg": __props.fontColor
                      }, {
                        default: _withCtx(() => [
                          _renderSlot(_ctx.$slots, "subline")
                        ]),
                        _: 3
                      }, 8, ["color-lg"]))
                    : _createCommentVNode("", true),
                  (hasContent.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["io-hero__content", `color-dark color-lg-${__props.fontColor}`])
                      }, [
                        _renderSlot(_ctx.$slots, "content")
                      ], 2))
                    : _createCommentVNode("", true),
                  (__props.pageUrl)
                    ? (_openBlock(), _createBlock(_component_IoRouterLink, {
                        key: 2,
                        "link-url": __props.pageUrl,
                        class: _normalizeClass(`btn btn-outline-dark btn-lg-bold btn-lg-outline-${__props.fontColor}`)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", { innerHTML: __props.pageUrlLabel }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                      }, 8, ["link-url", "class"]))
                    : _createCommentVNode("", true),
                  (__props.calculatorShow === 'true' && !isMobile.value)
                    ? (_openBlock(), _createBlock(_component_BaseCalculator, {
                        key: 3,
                        ref_key: "calculatorComponent",
                        ref: calculatorComponent,
                        "label-extra": __props.calculatorLabelExtra,
                        branches: __props.calculatorBranches,
                        "show-valid-checks": true,
                        onChangeUsageIcon: onCalculatorChangeIcon
                      }, null, 8, ["label-extra", "branches"]))
                    : _createCommentVNode("", true)
                ])
              ], 512)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["min-height", "vertical-center", "vertical-end"]),
    (_openBlock(), _createBlock(LazyBackgroundMedia, {
      ref_key: "background",
      ref: background,
      class: "io-hero__background",
      key: `hero-media-${currentMedia.value.id}`,
      "media-sizes": currentMedia.value.sizes,
      "background-position-y": currentMedia.value.positionY,
      "background-position-x": currentMedia.value.positionX
    }, null, 8, ["media-sizes", "background-position-y", "background-position-x"])),
    (__props.calculatorShow === 'true' && isMobile.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "heroCalculator",
          ref: heroCalculator,
          class: "io-hero__calculator"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_BaseCalculator, {
              ref_key: "calculatorComponent",
              ref: calculatorComponent,
              branches: __props.calculatorBranches,
              "label-extra": __props.calculatorLabelExtra,
              "show-valid-checks": true,
              onChangeUsageIcon: onCalculatorChangeIcon
            }, null, 8, ["branches", "label-extra"])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 512))
}
}

})